
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import {AxiosResponse} from "axios";
  
  @Component({
    name: "AgendarCita",
  })
  
  export default class AgendarCita extends Vue {
    @Prop() ventaEdit!: any
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    public codigo = '';
    public cuenta = '';
    public numero = '';
    cliente_seleccionado = '';
    pacientes_all = [];
    today= DateTime.now().toFormat("yyyy-MM-dd");
    
    reserva= {
        paciente_id: null,
        nombre: '',
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        detalle: '',
    }
    periodos = [{descripcion: 'Indefinido'},{descripcion: '1 año'},{descripcion: 'Unica ocasion'}]
    swEditar = true;
    valid = true;
    focus = ''
    type = 'week'
    typeToLabel = {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    }
    events = []
    selectedEvent = {}
    selectedElement = null
    selectedOpen = false
    inicio =DateTime.now().toFormat("yyyy-MM-dd")
    fin = DateTime.now().toFormat("yyyy-MM-dd")
    get pacientes(): any {
      return this.consultorioStore.pacientes;
    }
    get tratamientos(): any {
      return this.consultorioStore.tratamientos;
    }
    get reservas(): any {
      return this.consultorioStore.reservas;
    }
   
    txtSearch = "";
    selected_paciente = {};
    mounted(){
      this.getTratamientos();
      this.$refs.calendar.checkChange()
      this.$refs.calendar.scrollToTime('10:00')
    }
    
   
    closePaciente(){
      this.dialog=false;
    }
    newPaciente(){
      this.dialog = true;
    }
    asignarPaciente(paciente:any){
      this.paciente = paciente;
    }
    getPacientesSearch(value:string){
      this.loading
      this.consultorioService.getPacientesSearch(value).then(res => {
        //this.pacientes_all = res;
      })
    }
    getTratamientos(){
      this.consultorioService.getTratamientos()
    }
    getFuentes(){
      this.consultorioService.getFuentes()
    }
    agendar(date: Date){
        console.log(date);
    }
    
    guardarReserva(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
        
          return;
        }
      if(this.swEditar){
        Alert.confirm(`Se realizará el registro de la reserva del paciente ${this.reserva.nombre}`, 'Registrar nueva reserva?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.registrarReserva(this.reserva).then(response =>{
            this.consultorioService.getReservas({fechaInicial: this.inicio, fechaFinal: this.fin});
              this.limpiar()
              setTimeout(this.cargarEventos,2000)
            })
            
          }
        })
      }else {
        Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.editarVenta(this.venta)
            this.limpiar()
          }
        })
      }
      
    }
    seleccionCliente(){
      console.log(this.selected_paciente)
      if(this.paciente !== null){
        this.reserva.nombre = this.selected_paciente.nombre_completo;
        this.reserva.paciente_id = this.selected_paciente.id;
        
      }else
      this.limpiar()
      
    }
    de_editar(){
      if(Object.entries(this.$route.params).length == 0)
        return
      if( Object.entries(this.$route.params.ventaEdit).length !== 0 && this.$route.params.ventaEdit.constructor === Object){
        this.swEditar = false;
        
        this.cliente= {
          codigo: this.$route.params.ventaEdit.cliente.codigo,
          cuenta: this.$route.params.ventaEdit.cliente.cuenta,
          nombre: this.$route.params.ventaEdit.cliente.nombre,
          direccion: this.$route.params.ventaEdit.cliente.direccion,
          nit: this.$route.params.ventaEdit.cliente.nit,
          telefono: this.$route.params.ventaEdit.cliente.telefono,
          placa: this.$route.params.ventaEdit.cliente.placa,
          periodo: this.$route.params.ventaEdit.cliente.periodo,
        };
        this.venta = {
          codigo: this.$route.params.ventaEdit.codigo,
          cantidad_m3: this.$route.params.ventaEdit.cantidad_m3,
          total_venta: this.$route.params.ventaEdit.total_venta,
          fecha_hora: DateTime.now().toFormat('yyyy-MM-dd'),
          es_cancelado: this.$route.params.ventaEdit.es_cancelado,
          destino: this.$route.params.ventaEdit.destino,
          placa: this.$route.params.ventaEdit.placa,
          users_id: '',
          cliente_id: this.$route.params.ventaEdit.cliente.id,
          uso_id: this.$route.params.ventaEdit.uso_id,
          fuente_id: this.$route.params.ventaEdit.fuente_id,
          id: this.$route.params.ventaEdit.id,
         
        }
      }
    }
    limpiar(){
      this.reserva= {
        nombre: '',
        paciente_id: null,
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        detalle: '',
    }
    this.selected_paciente = {}
    }
    async getEvents(event){
      this.inicio = event.start.date
      this.fin = event.end.date
      this.consultorioService.getReservas({fechaInicial: this.inicio, fechaFinal: this.fin});
      await setTimeout(() => {
        this.cargarEventos()
      
      
      
      
      
    }, 2000);
    }
    cargarEventos() {
      let eventos = []
      if(this.reservas.length>0){
        this.reservas.forEach(element => {
          let inicio =DateTime.fromISO(element.fecha +'T'+ element.hora)
          let fin = DateTime.fromISO(element.fecha +'T'+ element.hora).plus({hours : 1})
          eventos.push({
            name: element.paciente.nombre_completo,
            start: inicio.toFormat("yyyy-MM-dd HH:mm:ss"),
            end: fin.toFormat("yyyy-MM-dd HH:mm:ss"),
            color: element.tratamiento.color,
            details: `${element.tratamiento?.nombre} <br> ${inicio.toFormat("yyyy-MM-dd HH:mm:ss")} <br>  ${element.detalle?element.detalle:""}` ,
          })
        });
      } 
      
        this.events = eventos;
    }
    setToday () {
      this.focus = ''
    }
    prev () {
      this.$refs.calendar.prev()
    }
    next () {
      this.$refs.calendar.next()
    }
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    @Watch('txtSearch')
    search(value: string) {
      if(value != null && value.length > 2){
        this.$nextTick().then( () => {
          this.getPacientesSearch(value);
        })
        
        this.pacientes_all = this.consultorioStore.pacientes;
      }
      
  
      
    }
  }
  
  